
import { Handle, Position } from 'reactflow';

export default function StartNode({ data }) {

    return (
        <>
            <div className='bg-sky-600 text-white rounded-xl p-2 px-4'>
                <span>{data.name}</span>
            </div>
            <Handle type="source" position={Position.Right} id="start" />
        </>
    );
}